"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AXSDateMode = exports.AXSDateDisplay = void 0;
var React = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var DateLine = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
});
var Weekday = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  text-transform: uppercase;\n  font-weight: bold;\n"], ["\n  color: ", ";\n  text-transform: uppercase;\n  font-weight: bold;\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_650);
});
var Month = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-transform: uppercase;\n"], ["\n  text-transform: uppercase;\n"])));
var Day = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-transform: uppercase;\n"], ["\n  text-transform: uppercase;\n"])));
var Time = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-transform: uppercase;\n"], ["\n  text-transform: uppercase;\n"])));
var Year = styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-weight: ", ";\n"], ["\n  font-weight: ",
    ";\n"])), function (_a) {
    var displayFormat = _a.displayFormat;
    return displayFormat === 'season' ? '700' : 'inherit';
});
var AXSDateDisplay = function (props) {
    var parsedDate = date_fns_1.parse(props.date);
    var dayOfWeek = date_fns_1.format(parsedDate, 'ddd');
    var month = date_fns_1.format(parsedDate, 'MMM');
    var day = date_fns_1.format(parsedDate, 'D');
    var year = date_fns_1.format(parsedDate, 'YYYY');
    var time = props.european
        ? date_fns_1.format(parsedDate, 'HH:mm')
        : date_fns_1.format(parsedDate, 'hh:mm A');
    return props.dateBlock ?
        React.createElement("div", null) : (React.createElement(DateLine, __assign({ inline: true, color: props.color }, props, { className: classnames_1.default(['c-axs-date-display', props.className]) }), props.displayFormat === 'japanese' ? (React.createElement("span", { className: "c-axs-date__wrapper" },
        React.createElement(Month, { className: "c-axs-date__month" }, month),
        ' ',
        React.createElement(Day, { className: "c-axs-date__day" }, day),
        props.displayYear && React.createElement(Year, null,
            " ",
            year),
        React.createElement(React.Fragment, null,
            ' ',
            "(",
            React.createElement(Weekday, { className: "c-axs-date__weekday", color: props.dayColor, theme: props.theme }, dayOfWeek),
            ")"),
        React.createElement(React.Fragment, null,
            ' ',
            "- ",
            React.createElement(Time, { className: "c-axs-date__time" }, time)))) : (React.createElement("span", { className: "c-axs-date__wrapper" },
        props.displayWeekday || props.displayFormat === 'full' ? (React.createElement(Weekday, { className: "c-axs-date__weekday", color: props.dayColor, theme: props.theme },
            dayOfWeek,
            ' ')) : null,
        ' ',
        props.displayFormat !== 'season' && (React.createElement(Month, { className: "c-axs-date__month" }, month)),
        ' ',
        props.displayFormat !== 'season' && (React.createElement(Day, { className: "c-axs-date__day" }, day)),
        (props.displayYear ||
            props.displayFormat === 'season' ||
            props.displayFormat === 'common') && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement(Year, { displayFormat: props.displayFormat }, year))),
        (props.displayTime ||
            props.displayFormat === 'common' ||
            props.displayFormat === 'full') && !props.omitTime && (React.createElement(React.Fragment, null,
            ' ',
            "- ",
            React.createElement(Time, { className: "c-axs-date__time" }, time))),
        props.displayFormat === 'season' && React.createElement("span", null, " Season")))));
};
exports.AXSDateDisplay = AXSDateDisplay;
AXSDateDisplay.defaultProps = {
    color: 'axsui.components.date.color',
    dayColor: 'axsui.components.date.dayColor',
    fontSize: '14px',
};
var AXSDateMode = function (_a) {
    var mode = _a.mode, date = _a.date;
    return React.createElement(AXSDateDisplay, { date: date });
};
exports.AXSDateMode = AXSDateMode;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map